export default "__VITE_ASSET__BFxg4uvF__"